import React from 'react'
import styles from './styles.module.css'
import Image from 'src/comps/Image'
import { useIntl } from 'react-intl'
import { LoadingSpinner } from './LoadingSpinner'
import { PATH_IMAGES_CDN } from 'src/constants/environment'
import { Text } from 'src/comps/Atom/Text'

const Loading3dsValidation = ({ isFirstLoad }: { isFirstLoad: boolean }) => {
  const intl = useIntl()

  return (
    <section className={styles.loader}>
      <div className={styles.message}>
        <LoadingSpinner />
        <div>
          <Text variant="captionL" weight="weight2">
            {intl.formatMessage({
              id: isFirstLoad ? 'redirect.copy-1' : 'redirect.copy-3',
            })}
          </Text>
          <Text variant="captionL" weight="weight2">
            {intl.formatMessage({ id: 'redirect.copy-2' })}
          </Text>
        </div>
      </div>
      {isFirstLoad && (
        <div className={styles.preloader}>
          <Image
            alt="An illustration of a person planting a flag"
            src={`${PATH_IMAGES_CDN}/250401_illustration-flag.png`}
            className={styles.preloaderImage}
          />
          <Text variant="titleXs" weight="weight4">
            {intl.formatMessage({ id: 'redirect.title' })}
          </Text>

          <Text variant="textBodyL" weight="weight2">
            {intl.formatMessage({ id: 'redirect.copy-4' })}
          </Text>
        </div>
      )}
    </section>
  )
}

export default Loading3dsValidation
